'use strict';

document.addEventListener('DOMContentLoaded', () => {

    // The Table
    function supremeTables(tableContainer) {
        const table = tableContainer.querySelector('.supreme-table'),
            tbody = table.querySelector('tbody'),
            tableBodyTr = table.querySelectorAll('tbody tr.sct-column'),
            navigation = tableContainer.querySelector('.sct-table-nav'),
            navigationBackward = navigation.querySelector('.backward'),
            navigationForward = navigation.querySelector('.forward'),
            navigationNumberCurrent = navigation.querySelector('.number-current'),
            tableNumberOfColumns = table.querySelectorAll('tbody tr.sct-column').length;

        let deviceWidth = window.innerWidth;

        let startX,
            startY,
            startTime = 0;

        let newTableWidth, tableWidth, tableBodyTrWidth, allowableAmount, tableMarginLeft, trWidthNew, navigationCurrentPosition, halfColumnWidth, tableColumnWidth;

        function getElementWidth(element, withPadding = true, withBorder = true, withMargin = false) {
            const style = window.getComputedStyle(element);
            let width = withBorder ? element.offsetWidth : element.clientWidth;

            if (!withPadding) {
                width -= parseInt(style['padding-left'], 10) + parseInt(style['padding-right'], 10);
            }
            if (withMargin) {
                width += parseInt(style['margin-left'], 10) + parseInt(style['margin-right'], 10);
            }

            return width;
        }


        function tableWidthCalculation() {
            // set width based on a wrapper element (good for page builders and responsive columns)
            newTableWidth = getElementWidth(tableContainer.parentNode, false, false, false);

            // add table max/min width
            table.style['max-width'] = `${newTableWidth}px`;
            table.style['min-width'] = `${newTableWidth}px`;

            // now set these vals
            tableWidth = getElementWidth(tableContainer.querySelector('tbody'), false, false, false);

            // check to see if there are any th
            if (tableBodyTr.length !== 0) {
                tableBodyTrWidth = parseInt(window.getComputedStyle(tableBodyTr[0])['max-width'], 10);
                allowableAmount = Math.floor(tableWidth / tableBodyTrWidth);
            } else {
                tableBodyTrWidth = 0;
                allowableAmount = 0;
            }

            tableMarginLeft = 0;
            trWidthNew = tableBodyTrWidth;

            tableBodyTr.forEach((tr) => {
                tr.style['min-width'] = 0;
            });

            // table navigation
            if (allowableAmount < tableNumberOfColumns) {

                trWidthNew = Math.round(tableWidth / allowableAmount);
                tableBodyTr.forEach((td) => {
                    td.style['min-width'] = `${trWidthNew}px`;
                });

            } else {
                tbody.style['width'] = `100%`;

                // recalc again
                tableWidth = getElementWidth(tableContainer.querySelector('tbody'), false, false, false);
                trWidthNew = Math.round(tableWidth / tableNumberOfColumns);

                tableBodyTr.forEach((td) => {
                    td.style['min-width'] = `${trWidthNew}px`;
                });
            }

            updateNavigation();
        }

        function updateNavigation() {
            navigationCurrentPosition = allowableAmount;
            navigationForward.classList.remove('disable');

            navigation.querySelector('.number-total').innerText = tableNumberOfColumns;
            navigationNumberCurrent.innerText = navigationCurrentPosition;
            navigationBackward.classList.add('disable');
        }

        function moveForward() {
            if (navigationCurrentPosition < tableNumberOfColumns) {
                navigationCurrentPosition += 1;
                navigationBackward.classList.remove('disable');
                navigationNumberCurrent.innerText = navigationCurrentPosition;
                tableMarginLeft -= trWidthNew;
                tbody.style['margin-left'] = `${tableMarginLeft}px`;
                if (navigationCurrentPosition === tableNumberOfColumns) {
                    navigationForward.classList.add('disable');
                }
            }
        }

        function moveBack() {
            if (navigationCurrentPosition > allowableAmount) {
                navigationForward.classList.remove('disable');
                navigationCurrentPosition -= 1;
                navigationNumberCurrent.innerText = navigationCurrentPosition;
                tableMarginLeft += trWidthNew;
                tbody.style['margin-left'] = `${tableMarginLeft}px`;
                if (navigationCurrentPosition === allowableAmount) {
                    navigationBackward.classList.add('disable');
                }
            }
        }


        // flexitable init
        function supremeTableInit(event) {
            tableWidthCalculation();
        }

        function initEvents() {
            // attach addEventListeners
            navigationForward.addEventListener('click', (event) => {
                event.preventDefault();
                moveForward();
            });
            navigationBackward.addEventListener('click', (event) => {
                event.preventDefault();
                moveBack();
            });

            // flexitable check onresize
            window.addEventListener('resize', (event) => {
                const deviceNewWidth = window.innerWidth;
                if (Math.abs(deviceNewWidth - deviceWidth) > 1) {
                    tbody.style.marginLeft = '0px';
                    deviceWidth = deviceNewWidth;
                    supremeTableInit(event);
                }
            });
        }

        function delayInit() {
            supremeTableInit();
            initEvents();
        }

        setTimeout(delayInit, 1000);
    }

    // there could be multiple tables on one page!
    const tableContainers = document.querySelectorAll('.supreme-table-container');
    tableContainers.forEach(container => {
        supremeTables(container);
    });

});